<template>
    <div>
      <div class="content-box">
        <div class="row">
          <div class="col-lg-12">
            <div class="element-wrapper">
              <div class="element-box">
                <form @submit="guardar">
                  <h5 v-if="actionForm == 'add'" class="form-header">
                    Asignar {{ typeForm[valueForm].name || 'Pos. Inexistente' }}
                  </h5>
                  <h5 v-if="actionForm == 'edit'" class="form-header">
                    Editar {{ typeForm[valueForm].name || 'Pos. Inexistente' }}
                  </h5>
                  <div class="form-desc">
                    {{ actionForm == 'add' ? "Asignación" : "Edición" }} de 
                    {{ typeForm[valueForm].name || 'Pos. Inexistente' }} en
                    {{ idAntecesor != 0 ? current.antecesor : 'Tienda' }}
                  </div>

                  <div class="row px-4 d-flex flex-wrap justify-content-center mb-2">
                    <div class="col-sm-4 col-md-3">
                      <div class="form-group">
                        <label
                          v-bind:class="{ 'text-danger': current.errors.posicion && current.errors.posicion.length > 0 }"
                        >{{ typeForm[valueForm].name || 'Tipo desconocido' }}</label>
                        <input
                          v-model="current.posicion"
                          autofocus="autofocus"
                          class="form-control text-muted custom-select custom-select-md form-control rounded bright w-100 text-center"
                          :placeholder="typeForm[valueForm].name || 'Tipo desconocido'"
                          type="text"
                          v-bind:class="{ 'is-invalid': current.errors.posicion && current.errors.posicion.length > 0 }"
                        >
                        <small
                          v-if="current.errors && current.errors.posicion"
                          class="form-text text-danger"
                        >{{ current.errors.posicion[0] }}</small>
                      </div>
                    </div>
                    <div class="col-sm-8 col-md-9">
                      <div class="form-group">
                        <label
                          v-bind:class="{ 'text-danger': current.errors.descripcion && current.errors.descripcion.length > 0 }"
                        >Descripción</label>
                        <input
                          v-model="current.descripcion"
                          class="form-control text-muted custom-select custom-select-md form-control rounded bright w-100 text-center"
                          placeholder="Descripción"
                          v-bind:class="{ 'is-invalid': current.errors.descripcion && current.errors.descripcion.length > 0 }"
                          type="text"
                        >
                        <small
                          v-if="current.errors && current.errors.id"
                          class="form-text text-danger"
                        >{{ current.errors.descripcion[0] }}</small>
                      </div>
                    </div>
                  </div>

                  <div class="row px-4 d-flex flex-wrap justify-content-center mb-2">
                    <div class="col-sm-12 col-md-6 flex-wrap justify-content-center mt-3">
                        <div class="form-group">
                          <label
                            v-bind:class="{ 'text-danger': current.errors.ancestor && current.errors.ancestor.length > 0 }"
                          >
                            {{ current.antecesor }}  
                          </label>
                          <select
                            class="form-control text-muted custom-select custom-select-md form-control rounded bright w-100 text-center"
                            autofocus="autofocus"
                            v-model="current.antecesorId"
                            @input="$emit('input', $event.target.value)"
                          >
                            <option
                            v-for="(item, index) in currentSelectFormFormatted"
                              :value="valueForm != 'BD' ? item.id : item.codigo"
                              :key="index"
                            >
                              {{ 
                                valueForm != 'BD' ?
                                  item.posicion_valor + " - " + item.descripcion : item.posicion_valor
                              }}
                            </option>
                          </select>
                          <small
                            v-if="current.errors && current.errors.ancestor"
                            class="form-text text-danger"
                          >{{ current.errors.ancestor[0] }}</small>
                        </div>
                      </div>
                      <div v-if="valueForm == 'PS'" class="col-sm-12 col-md-6 flex-wrap justify-content-center mt-3">
                        <div v-if="listadoTiposPosiciones" >
                          <div class="form-group">
                          <label
                            v-bind:class="{ 'text-danger': current.errors.descripcion && current.errors.descripcion.length > 0 }"
                          >Tipo De Posición</label>
                          <select v-model="current.tipo_posicion" class="text-muted custom-select custom-select-md form-control rounded bright w-100 text-center">
                            <option selected value="">Tipo De Posición</option>
                            <option v-for="(item,index) in listadoTiposPosiciones" :key="index" :value="item.llave">{{item.valor}}</option>
                          </select>
                        </div>
                        </div>
                      </div>
                  </div>

                  <div 
                    v-if="currentAntecesorObj.estatus == true || currentAntecesorObj.activa == true"
                    class="row d-flex flex-wrap justify-content-center align-items-center"
                  >
                    <div class="col-12 col-md-2 col-lg-1 d-flex justify-content-center">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            name="optionsRadios"
                            v-model="current.estatus"
                            type="radio"
                            value="true"
                            >Activo
                        </label>
                      </div>
                    </div>
                    <div class="col-12 col-md-2 col-lg-1 d-flex justify-content-center py-2">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            v-model="current.estatus"
                            name="optionsRadios"
                            type="radio"
                            value="false"
                            >Inactivo
                        </label>
                      </div>
                    </div>
                  </div>
                  <div 
                    v-if="actionForm == 'add' && valueForm == 'BD'"
                    class="row d-flex flex-wrap justify-content-center align-items-center"
                  >
                    <div class="col-12 col-md-2 col-lg-1 d-flex justify-content-center">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            name="optionsRadios"
                            v-model="current.estatus"
                            type="radio"
                            value="true"
                            >Activo
                        </label>
                      </div>
                    </div>
                    <div class="col-12 col-md-2 col-lg-1 d-flex justify-content-center py-2">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            v-model="current.estatus"
                            name="optionsRadios"
                            type="radio"
                            value="false"
                            >Inactivo
                        </label>
                      </div>
                    </div>
                  </div>

                  <div v-if="valueForm == 'PS'" class="row pt-4 d-flex flex-wrap justify-content-center align-items-center">
                    <div class="col-6 col-md-2">
                      <div class="form-check d-flex align-items-center pb-4">
                        <input class="form-check-input" type="checkbox" v-model="current.predeterminada" id="chkPredeterminada" :true-value="true" :false-value="false">
                        <label class="form-check-label" for="chkPredeterminada">Predeterminada</label>
                      </div>
                    </div>
                    <div class="col-6 col-md-2">
                      <div class="form-check d-flex align-items-center pb-4">
                        <input class="form-check-input" type="checkbox" v-model="current.para_venta" id="chkParaVenta" :true-value="true" :false-value="false">
                        <label class="form-check-label" for="chkParaVenta">Para Venta</label>
                      </div>
                    </div>
                    <div class="col-6 col-md-2">
                      <div class="form-check d-flex align-items-center pb-4">
                        <input class="form-check-input" type="checkbox" v-model="current.transitoria" id="chkTransitoria" :true-value="true" :false-value="false">
                        <label class="form-check-label" for="chkTransitoria">Transitoria</label>
                      </div>
                    </div>
                    <div class="col-6 col-md-2">
                      <div class="form-check d-flex align-items-center pb-4">
                        <input class="form-check-input" type="checkbox" v-model="current.para_inconsistencias" id="chkInconsistencias" :true-value="true" :false-value="false">
                        <label class="form-check-label" for="chkInconsistencias">Para Inconsistencias</label>
                      </div>
                    </div>
                    <div class="col-6 col-md-2">
                      <div class="form-check d-flex align-items-center pb-4">
                        <input class="form-check-input" type="checkbox" v-model="current.para_contenedor" id="chkContenedor" :true-value="true" :false-value="false">
                        <label class="form-check-label" for="chkContenedor">Para Contenedor</label>
                      </div>
                    </div>
                  </div>

                  <div 
                    v-if="currentAntecesorObj.estatus == false || currentAntecesorObj.activa == false"
                    class="form-buttons-w"
                  >
                    <button  class="btn btn-primary" type="submit" >
                      Guardar
                    </button>
                    <div class="btn btn-link" @click="onCaseRouter(current, true)">
                      <i class="fa fa-back"></i>
                      Volver Atrás
                    </div>
                  </div>
                  <div 
                    v-if="currentAntecesorObj.estatus == true || currentAntecesorObj.activa == true"
                    class="form-buttons-w"
                  >
                    <button v-if="actionForm == 'add'" class="btn btn-primary" type="submit" >
                      Guardar
                    </button>
                    <button v-if="actionForm == 'edit' && (current.estatus == 'true' || current.estatus == true || current.estatus == null)" class="btn btn-primary" type="submit" >
                      Guardar
                    </button>
                    <div v-if="actionForm == 'edit' && (current.estatus == 'false' || current.estatus == false || current.estatus == null)" class="btn btn-info" @click="modalHandler()">
                      Guardar
                    </div>
                    <div class="btn btn-link" @click="onCaseRouter(current, true)">
                      <i class="fa fa-back"></i>
                      Volver Atrás
                    </div>
                  </div>
                  <div 
                    v-else
                    class="form-buttons-w"
                  >
                    <button  class="btn btn-primary" type="submit" >
                      Guardar
                    </button>
                    <div class="btn btn-link" @click="onCaseRouter(current, true)">
                      <i class="fa fa-back"></i>
                      Volver Atrás
                    </div>
                  </div>

                  <!-- MODAL CONFIRMAR DESACTIVACION POSICIÓN -->
                  <div
                    v-if="actionForm == 'edit' && (current.estatus == 'false' || current.estatus == false || current.estatus == null)"
                    aria-hidden="true"
                    class="modal fade"
                    id="modalConfirmacionEstatusModify"
                    role="dialog"
                    tabindex="-1"
                  >
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header faded smaller red_gradient_bg">
                          <h5 class="modal-title text-white">Desactivación de {{ typeForm[valueForm].name }}</h5>
                          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <h6 class="modal-title">
                            La siguiente acción desactivará automáticamente todas las posiciones inferiores
                            contenidas en: ({{ current.posicion +" - "+ current.descripcion }})
                          </h6>

                          <b>
                            <h6 class="modal-title mt-3 font-weight-bold">
                              ¿Está Seguro de continuar con esta acción?
                            </h6>
                          </b>
                        </div>
                        <div class="modal-footer">
                          <button class="btn btn-danger" type="submit" >
                            Continuar
                          </button>
                          <div
                            class="btn btn-outline-info"
                            ref="cerrarModal"
                            data-dismiss="modal"
                          >
                            Cancelar
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      
    </div>
  </template>
  
  <script>
  import Notifications from "@/notifications/notifications";
  //servicios para posiciones
  import TiendaBodegaService from "@/services/catalogos/TiendaBodegaService";
  import BodegaSeccionService from "@/services/catalogos/BodegaSeccionService";
  import SeccionRackService from "@/services/catalogos/SeccionRackService";
  import RackNivelService from "@/services/catalogos/RackNivelService";
  import NivelPosicionService from "@/services/catalogos/NivelPosicionService";
  //servicios para select form
  import TiendaService from "@/services/catalogos/TiendaService";
  //servicio dinamico para select tipo posicion
  import DynamicService from "@/services/commons/DynamicService";
  
  export default {
    data() {
      return {
        /**
         * typeForm:
         * lista de tipos de Posiciónes y su respectivo servicio a consumir, 
         * la cual nos sirve para indicar que tipo de posición 
         * asignaremos o editaremos
         */
        typeForm: {
          BD: {name: 'Bodega', service: TiendaBodegaService},
          SC: {name: 'Sección', service: BodegaSeccionService},
          RK: {name: 'Rack', service: SeccionRackService},
          NV: {name: 'Nivel', service: RackNivelService},
          PS: {name: 'Posición', service: NivelPosicionService},
        },

        /**
         * valueForm:
         * Es la variable que recibe el valor de posición
         * que se asignara o editara.
         */
        valueForm: this.$route.params.valueForm,

        /**
         * actionForm:
         * Es la variable que recibe el tipo de acción a
         * realizar, esta puede ser: add || edit
         */
        actionForm: this.$route.params.actionForm,

        /**
         * idAntecesor:
         * Variable que se utiliza en caso de asignación
         * de nueva posición, esta nos indica el valor 
         * mayor/padre/antecesor, de nuestra nueva posición.
         */
        idAntecesor: this.$route.params.idAntecesor,

        /**
         * idCurrent:
         * Variable que se utiliza en caso de edición de
         * los valores de una posición, esta indica el valor
         * actual de la posición a editar
         */
        idCurrent: this.$route.params.idCurrent,

        /**
         * OBJETOS DE POSICIONES AL EDITARLAS
         */
        currentBodega: {},
        currentSeccion: {},
        currentRack: {},
        currentNivel: {},
        currentPosicion: {},

        /**
         * Data del objeto del formulario actual
         */
        current: {
          estatus: true,
          errors: {}
        },

        /**
         * Data del anterior estado del objeto del formulario actual,
         * nos sirve para saber si el objeto modificara su estatus o no
         */
        currentOldToEdit: {
          estatus: null,
          errors: {}
        },

        /**
         * Objeto utilizado para guardar la data del
         * objeto antecesor, para realizar validaciones
         * de estatus, para limitar la edicion si el antecesor
         * esta inactivo.
         */
        currentAntecesorObj: {},

        /**
         * Esta Variable nos sirve para lograr la
         * dinamicidad de datos mostrados en el select Form
         * de objeto Antecesor, en caso de que se requiera editar.
         */
        currentSelectForm: {},
        currentSelectFormFormatted: {},

        /**
         * Servicio Activo Actual
         */
        servicioActivo: {},

        /**
         * Listado De Tipos de Posiciónes para 
         * el select de Tipo de Posicion en caso de "PS"
         */
        listadoTiposPosiciones: {}
      };
    },
    watch:{
      /**
       * Fragmentos de código en watch, que nos setean la data a editar
       * en los formularios, dependiendo del caso de uso y la
       * data que necesitemos modificar
       */
      currentBodega(newValue) {
        if (this.valueForm == "BD") {
          if (this.actionForm == "edit") {
            this.current.posicion = newValue.bodega;
            this.current.descripcion = newValue.descripcion;
            this.current.estatus = newValue.estatus;
          }
        }
      },
      currentSeccion(newValue) {
        if (this.valueForm == "SC") {
          if (this.actionForm == "edit") {
            this.current.posicion = newValue.seccion;
            this.current.descripcion = newValue.descripcion;
            this.current.estatus = newValue.estatus;
          }
        }
      },
      currentRack(newValue) {
        if(this.valueForm == "RK") {
          if (this.actionForm == "edit") {
            this.current.posicion = newValue.rack;
            this.current.descripcion = newValue.descripcion;
            this.current.estatus = newValue.estatus;
          }
        }
      },
      currentNivel(newValue) {
        if(this.valueForm == "NV") {
          if (this.actionForm == "edit") {
            this.current.posicion = newValue.nivel;
            this.current.descripcion = newValue.descripcion;
            this.current.estatus = newValue.estatus;
          }
        }
      },
      currentPosicion(newValue) {
        if(this.valueForm == "PS") {
          if (this.actionForm == "edit") {
            console.log("NVAL", newValue)
            this.current = this.buildData(newValue, 0)
            
          }
        }
      },
      /**
       * Setea antecesor en cada cambio de current,
       * esto porque se eliminaba luego de actualizar
       * el current
       */
      current: {
        handler(newValue, oldValue) {
          console.log("newValue", newValue);
          console.log("oldValue", oldValue);
          this.currentOldToEdit = oldValue;
          if(newValue == oldValue) return;
          switch (this.valueForm) {
            case 'BD':
              this.current.antecesor = "Tienda";
              this.servicioActivo = this.typeForm.BD.service;
              break;
            case 'SC':
              this.current.antecesor = "Bodega";
              this.servicioActivo = this.typeForm.SC.service;
              break;
            case 'RK':
              this.current.antecesor = "Sección";
              this.servicioActivo = this.typeForm.RK.service;
              break;
            case 'NV':
              this.current.antecesor = "Rack"
              this.servicioActivo = this.typeForm.NV.service;
              break;
            case 'PS':
              this.current.antecesor = "Nivel"
              this.servicioActivo = this.typeForm.PS.service;
              break;
            default:
              return 'Formulario desconocido';
        }
        },
        immediate: true
      },

      /**
       * Elemento Watcher que setea la data en el select y
       * sobreescribe la posicion de identidad (BD, SC, etc...) de la posición
       * dependiendo de que valor sea el que se necesita setear,
       * 
       * esto se hizo para poder renderizar todos los tipos de datos
       * ancestros que puedan haber, en el mismo select, sin necesidad
       * de hacer condicionales innecesarias que rendericen varios select forms. 
       */
      currentSelectForm(newValue) {
        //diccionario de posiciones posibles
        const dictClaves = ["nombre", "posicion", "nivel", "rack", "seccion", "bodega", "tienda"];

        //ciclo que genera el nuevo objeto formateado
        const resultado = newValue.map(obj => {
          const nuevoObj = { ...obj };
          
          //filter para conocer que tipo de claves contiene nuestro objeto
          const clavesPresentes = dictClaves.filter(clave => obj.hasOwnProperty(clave));
          
          //ciclo que substituye la posicion, por el valor posicion_valor.
          for (const clave of dictClaves) {
            if (nuevoObj.hasOwnProperty(clave)) {

              //ciclo que valida que el select no agarre tienda como valor a editar
              //ya que todos los objetos contienen "posicion" y "tienda"
              if (clave === "tienda" && clavesPresentes.length > 1) {
                continue;
              }
              nuevoObj.posicion_valor = nuevoObj[clave];
              delete nuevoObj[clave];
              break;
            }
          }
          return nuevoObj;
        });
        this.currentSelectFormFormatted = resultado;
      }
    },
    mounted() {

      /**
       * ASIGNAR NUEVA POSICIÓN
       * En Caso de Recibir:
       * -> idAntecesor && 'add'
       * 
       * Se realiza la siguiente logica, para setear data de sus respectivos
       * datos padre/antecesor en cada caso, así se mantiene una correcta lógica
       * de asignación, en su relación de posición padre/antecesor -> hijo/sucesor...
       */
      if (
        (this.idAntecesor && this.actionForm == 'add') || 
        (this.idAntecesor == 0 && this.valueForm == 'BD' && this.actionForm == 'add')) 
      {
        let typeData = this.typeForm[this.valueForm];
        console.log("add")
        if (typeData) {
          switch (this.valueForm) {
            case 'BD':
              this.current.antecesor = "Tienda";
              this.servicioActivo = this.typeForm.BD.service;
              this.getBodega(this.idAntecesor);
              break;
            case 'SC':
              this.current.antecesor = "Bodega";
              this.servicioActivo = this.typeForm.SC.service;
              this.getBodega(this.idAntecesor);
              break;
            case 'RK':
              this.current.antecesor = "Sección";
              this.servicioActivo = this.typeForm.RK.service;
              this.getSeccion(this.idAntecesor);
              break;
            case 'NV':
              this.current.antecesor = 'Rack'
              this.servicioActivo = this.typeForm.NV.service
              this.getRack(this.idAntecesor);
              break;
            case 'PS':
              this.getTiposPosicion();
              this.current.antecesor = 'Nivel'
              this.servicioActivo = this.typeForm.PS.service
              this.getNivel(this.idAntecesor);
              break;
            default:
              return 'Formulario desconocido';
          }
        } else {
          this.errorHandler("Esa clave de posición no existe.");
        }
      }

      /**
       * EDITAR POSICIÓN EXISTENTE
       * En Caso de Recibir:
       * -> idCurrent && 'edit'
       * 
       * Se realiza la siguiente logica, para setear data de sus respectivos
       * datos padre/antecesor en cada caso, así se mantiene una correcta lógica
       * de asignación, en su relación de posición padre/antecesor -> hijo/sucesor...
       */
       if (this.idCurrent && this.actionForm == 'edit') {
        let typeData = this.typeForm[this.valueForm];
        console.log("edit")
        if (typeData) {
          switch (this.valueForm) {
            case 'BD':
              this.current.antecesor = "Tienda";
              this.servicioActivo = this.typeForm.BD.service;
              this.getBodega(this.idCurrent);
              break;
            case 'SC':
              this.current.antecesor = "Bodega";
              this.servicioActivo = this.typeForm.SC.service;
              this.getSeccion(this.idCurrent);
              break;
            case 'RK':
              this.current.antecesor = "Sección";
              this.servicioActivo = this.typeForm.RK.service;
              this.getRack(this.idCurrent);
              break;
            case 'NV':
              this.current.antecesor = 'Rack'
              this.servicioActivo = this.typeForm.NV.service
              this.getNivel(this.idCurrent);
              break;
            case 'PS':
              this.getTiposPosicion();
              this.current.antecesor = 'Nivel'
              this.servicioActivo = this.typeForm.PS.service
              this.getPosicion(this.idCurrent);
              break;
            default:
              return 'Formulario desconocido';
          }
        } else {
          this.errorHandler("Esa clave de posición no existe.");
        }
      }
    },
    methods: {
      /**
       * Los Siguientes métodos, nos sirven para una correcta obtención de
       * datos dependientes, ya que las posiciónes siempre dependeran de una
       * Posición mayor/antecesor/padre
       */
      async getBodega(idBodega) {
        if (this.idAntecesor != 0) {
          await TiendaBodegaService.getById(idBodega? idBodega: this.currentSeccion.idAntecesor).then(response => {
            this.currentBodega = response.data;
            this.currentBodega.errors = [];
            this.current.tienda = this.currentBodega.tienda;
            this.getAntecesorsSelectData(this.current.tienda);
            // Seteo de Seccion Ancestra
            if (this.valueForm == 'SC') {
              this.current.antecesorId = this.currentBodega.id;
              this.currentAntecesorObj = this.currentBodega;
            }
            console.log(this.currentAntecesorObj)
            console.log("BD: ",this.currentBodega.estatus);
          });
        } else {
          this.getAntecesorsSelectData(this.current.tienda);
        }
      },
      async getSeccion(idSeccion) {
        await BodegaSeccionService.getById(idSeccion ? idSeccion : this.$route.params.idAntecesor).then(response => {
          this.currentSeccion = response.data;
          this.currentSeccion.errors = [];
          this.current.tienda = this.currentSeccion.tienda;
          // Seteo de Seccion Ancestra
          if (this.valueForm == 'RK') {
            this.current.antecesorId = this.currentSeccion.id;
            this.currentAntecesorObj = this.currentSeccion;
          }
          this.getBodega(this.currentSeccion.bodega);
          console.log("SC: ",this.currentSeccion)
        });
      },
      async getRack(idRack) {
        await SeccionRackService.getById(idRack ? idRack : this.$route.params.idAntecesor).then(response => {
          this.currentRack = response.data;
          this.currentRack.errors = [];
          this.current.tienda = this.currentRack.tienda;
          // Seteo de Seccion Ancestra
          if (this.valueForm == 'NV') {
            this.current.antecesorId = this.currentRack.id;
            this.currentAntecesorObj = this.currentRack;
          }
          this.getSeccion(this.currentRack.seccion);
          console.log("RK: ",this.currentRack);
        });
      },
      async getNivel(idNivel) {
        await RackNivelService.getById(idNivel ? idNivel : this.$route.params.idAntecesor).then(response => {
          this.currentNivel = response.data;
          this.currentNivel.errors = [];
          this.current.tienda = this.currentNivel.tienda;
          // Seteo de Seccion Ancestra
          if (this.valueForm == 'PS') {
            this.current.antecesorId = this.currentNivel.id;
            this.currentAntecesorObj = this.currentNivel;
          }
          this.getRack(this.currentNivel.rack);
          console.log("NV: ",this.currentNivel);
        });
      },
      async getPosicion(idPosicion) {
        await NivelPosicionService.getById(idPosicion ? idPosicion : this.$route.params.idAntecesor).then(response => {
          this.currentPosicion = response.data;
          this.currentPosicion.errors = [];
          this.current.tienda = this.currentPosicion.tienda;
          this.getNivel(this.currentPosicion.nivel);
          console.log("PS: ",this.currentPosicion);
        });
      },

      /**
       * Función que obtiene los tipos de Posicion-Posicion
       * para setearlo en las posiciones, cuando el valor de posiciom == "PS"
       */
      async getTiposPosicion() {
        await DynamicService.getActionList(
          "cat",
          "tienda-posicion",
          "lista_tipo_posicion"
        ).then((response) => {
          this.listadoTiposPosiciones = response.data;
        });
      },
      /**
       * Método que nos maneja los errores de
       * obtención de data
       */
      errorHandler(message) {
        Notifications.alert.error(
          "error",
          message
        );
        this.$router.go(-1);
      },

      /**
       * Seteo de Data de Selector de Objeto Ancestro/Padre
       * 
       * Nos sirve para obtener la data del selector dependiendo el 
       * caso de operación del formulario
       */
      getAntecesorsSelectData(tienda) {
        if (this.valueForm) {
          let typeData = this.typeForm[this.valueForm];
          if (typeData) {
            switch (this.valueForm) {
              case 'BD':
                TiendaService.fetch({ quitar_paginacion: true }).then(res => {
                  this.currentSelectForm = res.data;
                  // Seteo de Tienda Antecesor
                  let tiendaAntecesor ={};
                  if (tienda) tiendaAntecesor = this.currentSelectForm.find(obj => obj.codigo == tienda);
                  this.current.antecesorId = tiendaAntecesor.codigo;
                  this.currentAntecesorObj = tiendaAntecesor;
                  console.log(this.currentAntecesorObj)
                });
                break;
              case 'SC':
                TiendaBodegaService.fetch({ quitar_paginacion: true, tienda: tienda}).then(res => {
                  this.currentSelectForm = res.data;
                });
                break;
              case 'RK':
                BodegaSeccionService.fetch({ quitar_paginacion: true, tienda: tienda, bodega: this.currentBodega.id }).then(res => {
                  this.currentSelectForm = res.data;
                });
                break;
              case 'NV':
                SeccionRackService.fetch({ quitar_paginacion: true, tienda: tienda, seccion: this.currentSeccion.id }).then(res => {
                  this.currentSelectForm = res.data;
                });
                break;
              case 'PS':
                RackNivelService.fetch({ quitar_paginacion: true, tienda: tienda, rack: this.currentRack.id }).then(res => {
                  this.currentSelectForm = res.data;
                });
                break;
              default:
                console.log('Formulario desconocido');
                break;
            }
          } else {
            this.errorHandler("Esa clave de posición no existe.");
          }
        }
      },

      /**
       * Método que construye el objeto a guardar/mostrar según el
       * tipo de formulario en edicion.
       * 
       * typeBuild = 1:
       * Nos Construye objeto para Enviar al Backend.
       * 
       * typeBuild = 0:
       * Nos Construye objeto para Setear en Formulario.
       * 
       * La razón de esto es que las posiciones en el objeto no tienen un nombre genérico
       * para poder setear en formulario y por esa razón, se tiene que construir 
       * el objeto estandarizado, tanto para mostrar en formulario y editar la data
       * como para luego enviar esa data modificada o nueva al backend, dependiendo
       * el tipo de posición que se haya editado o asignado.
       */
      buildData(dataToBuild, typeBuild) {
        if (typeBuild == 1) {
          switch (this.valueForm) {
            case 'BD':
              return {
                bodega: dataToBuild.posicion,
                descripcion: dataToBuild.descripcion,
                estatus: dataToBuild.estatus,
                tienda: dataToBuild.antecesorId
              }
            case 'SC':
              return {
                seccion: dataToBuild.posicion,
                descripcion: dataToBuild.descripcion,
                estatus: dataToBuild.estatus,
                bodega: dataToBuild.antecesorId,
                tienda: dataToBuild.tienda
              }
            case 'RK':
              return {
                rack: dataToBuild.posicion,
                descripcion: dataToBuild.descripcion,
                estatus: dataToBuild.estatus,
                seccion: dataToBuild.antecesorId,
                tienda: dataToBuild.tienda
              }
            case 'NV':
              return {
                nivel: dataToBuild.posicion,
                descripcion: dataToBuild.descripcion,
                estatus: dataToBuild.estatus,
                rack: dataToBuild.antecesorId,
                tienda: dataToBuild.tienda
              }
            case 'PS':
              return {
                posicion: dataToBuild.posicion,
                descripcion: dataToBuild.descripcion,
                estatus: dataToBuild.estatus,
                nivel: dataToBuild.antecesorId,
                tienda: dataToBuild.tienda,
                tipo_posicion: dataToBuild.tipo_posicion,
                predeterminada: dataToBuild.predeterminada,
                para_venta: dataToBuild.para_venta,
                transitoria: dataToBuild.transitoria,
                para_inconsistencias: dataToBuild.para_inconsistencias,
                para_contenedor: dataToBuild.para_contenedor,
                errors: []
              }
            default:
              return 'Formulario desconocido';
          }
        }
        if (typeBuild == 0) {
          switch (this.valueForm) {
            case 'BD':
              return {
                posicion: dataToBuild.bodega,
                descripcion: dataToBuild.descripcion,
                estatus: dataToBuild.estatus,
                antecesorId: dataToBuild.tienda
              }
            case 'SC':
              return {
                posicion: dataToBuild.seccion,
                descripcion: dataToBuild.descripcion,
                estatus: dataToBuild.estatus,
                antecesorId: dataToBuild.bodega,
                tienda: dataToBuild.tienda
              }
            case 'RK':
              return {
                posicion: dataToBuild.rack,
                descripcion: dataToBuild.descripcion,
                estatus: dataToBuild.estatus,
                antecesorId: dataToBuild.seccion,
                tienda: dataToBuild.tienda
              }
            case 'NV':
              return {
                posicion: dataToBuild.nivel,
                descripcion: dataToBuild.descripcion,
                estatus: dataToBuild.estatus,
                antecesorId: dataToBuild.rack,
                tienda: dataToBuild.tienda
              }
            case 'PS':
              return {
                posicion: dataToBuild.posicion,
                descripcion: dataToBuild.descripcion,
                estatus: dataToBuild.estatus,
                antecesorId: dataToBuild.nivel,
                tienda: dataToBuild.tienda,
                tipo_posicion: dataToBuild.tipo_posicion,
                predeterminada: dataToBuild.predeterminada,
                para_venta: dataToBuild.para_venta,
                transitoria: dataToBuild.transitoria,
                para_inconsistencias: dataToBuild.para_inconsistencias,
                para_contenedor: dataToBuild.para_contenedor,
                errors: []
              }
            default:
              return 'Formulario desconocido';
          }
        }
      },

      /**
       * Switch que nos devuelve un objeto con los parametros
       * utilizados por la funcion router, para cada caso de
       * asignación de Posición
       */
      onCaseRouter(data, isReturn) {
        switch (this.valueForm) {
          case 'BD': {
            let idItem = data.id ? data.id : data.idBodega;
            let routerParams = {};
            if(isReturn){
              routerParams = {
                name: 'cat-tienda-bodega',
                params: {}
              }
            }
            if(!isReturn){
              routerParams = {
                name: 'cat-position-editar',
                params: { 
                  typeForm: 'BD', 
                  actionForm: 'edit', 
                  idCurrent: idItem
                }
              }
            }
            this.$router.push(routerParams);
            break;
          }
          case 'SC': {
            let routerParams = {};
            if (isReturn && this.actionForm == 'add') {
              routerParams = {
                name: 'cat-tienda-bodega',
                params: {}
              }
            }
            if (isReturn && this.actionForm == 'edit') {
              let idItem = this.currentSeccion.id ? this.currentSeccion.id : data.id;
              routerParams = {
                name: 'cat-seccion-bodega-id',
                params: { idSeccion: idItem },
                props: { bodegaObj: this.currentBodega.id }
              }
            }
            if (!isReturn) {
              let idItem = this.currentSeccion.id ? this.currentSeccion.id : data.id;
              routerParams = {
                name: 'cat-seccion-bodega-id',
                params: { idSeccion: idItem },
                props: { bodegaObj: this.currentBodega.id }
              }
            }
            this.$router.push(routerParams);
            break;
          }
          case 'RK': {
            let routerParams = {
              name: 'cat-seccion-bodega-id',
              params: { idSeccion: this.currentSeccion.id },
              props: { bodegaObj: this.currentBodega.id }
            }
            this.$router.push(routerParams);
            break;
          }
          case 'NV': {
            let routerParams = {};
            if (isReturn && this.actionForm == 'add') {
              routerParams = {
                name: 'cat-seccion-bodega-id',
                params: { idSeccion: this.currentSeccion.id },
                props: { bodegaObj: this.currentBodega.id }
              }
            }
            if (isReturn && this.actionForm == 'edit') {
              routerParams = {
                name: 'cat-nivel-rack-id',
                params: { idNivel: this.currentNivel.id },
                props: { bodegaObj: this.currentBodega.id }
              }
            }
            if (!isReturn) {
              let idItem = this.currentNivel.id ? this.currentNivel.id : data.id;
              routerParams = {
                name: 'cat-nivel-rack-id',
                params: { idNivel: idItem },
              }
            }
            this.$router.push(routerParams);
            break;
          }
          case 'PS':
          let routerParams = {};
            if (isReturn) {
              routerParams = {
                name: 'cat-nivel-rack-id',
                params: { idNivel: this.currentNivel.id },
                props: { bodegaObj: this.currentBodega.id }
              }
            }
            if (!isReturn && this.actionForm == 'add' || this.actionForm == 'edit') {
              routerParams = {
                name: 'cat-nivel-rack-id',
                params: { idNivel: this.currentNivel.id },
                props: { bodegaObj: this.currentBodega.id }
              }
            }
            this.$router.push(routerParams);
            break;
          default:
            return 'Formulario desconocido';
        }
      },

      modalHandler() {
        $("#modalConfirmacionEstatusModify").modal();
      },

      guardar(e) {
        let self = this;
        e.preventDefault();
        $("#modalConfirmacionEstatusModify").modal('hide');
        var current = Object.assign({}, self.current);
        let dataToSave = this.buildData(current, 1);
        if (this.$route.params.idCurrent) {
          dataToSave.pk = this.$route.params.idCurrent;
        }
        this.servicioActivo.save(dataToSave)
          .then(res => {
            self.current = this.buildData(res.data, 0);
            self.current.errors = {};
            console.log(res.data)
            Notifications.alert.success(
              this.typeForm[this.valueForm].name,
              "Se ha guardado la Información."
            );
            this.onCaseRouter(res.data, false);
          })
          .catch(error => {
            Vue.nextTick(function() {
              self.current.errors = Object.assign({}, error.response.data);
              console.log(self.current.errors);
            });
          });
      },
      showModal(e) {
        e.preventDefault();
      }
    }
  };
  </script>
  